import { useQuery } from "@tanstack/vue-query"

export const PRODUCT_TAG_QUERY_KEY = "productTags"

export const useProductTags = () => {
  const { data, isFetching } = useQuery({
    queryKey: [PRODUCT_TAG_QUERY_KEY],
    queryFn: () => listProductTags(),
    staleTime: 60 * 60 * 1000,
  })

  const getById = (productTagId: string) =>
    computed(() =>
      data.value?.find(
        (productTag) => productTag.id === productTagId
      )
    )
  return {
    data,
    isFetching,
    getById,
    asOptions: computed(
      () =>
        data.value?.map(({ label, id }) => ({
          value: id,
          label: label,
        })) || []
    ),
  }
}
